<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-server</v-icon>{{$t('industrialcomputer.industrialcomputers')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <IndustrialComputerForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import IndustrialComputerForm from '../../components/industrialcomputer/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'IndustrialComputer';

const { mapFields } = createHelpers({
  getterType: 'industrialcomputer/getField',
  mutationType: 'industrialcomputer/updateField'
});

export default {
  name: 'IndustrialComputerCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    IndustrialComputerForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('industrialcomputer', ['create', 'reset'])
  }
};
</script>
